import { PerspectivesApi } from 'api/PerspectivesApi';
import { apiClient } from 'container/apiClient';

export const perspectivesApi = new PerspectivesApi(apiClient);
